import React from "react";

import Image from "/components/cms/image";
import { Block, Flex } from "/components/Layout";
import Button from "/components/Button";
import RadioButton from "/components/RadioButton";

import CartContext from "/context/cart";
import { trackPixel } from "/utils/metaPixel";

import styles from "./SubscriptionLength.module.scss";

const SubscriptionLength = ({ nextStep, prevStep }: any) => {
  const cart = React.useContext(CartContext);
  const title = cart.state?.bike?.cms?.title || "";

  // Step 1 → 2: the user picked a subscription and is entering the checkout flow.
  const goToNextStep = () => {
    trackPixel("InitiateCheckout", { content_name: title });
    nextStep();
  };
  const image = cart.state?.bike?.cms?.image;
  const selectedSubId = cart.state?.subscription?.id;
  const possibleSubscriptions = (cart.state.bike?.bikeSubscriptions || []).map((item) => {
    return {
      id: item.id,
      title: item.name,
      price: item.price,
      commitmentTime: item.subscriptionProductCondition,
      disabled: !item.canBePurchasedOnline
    };
  });

  const onInputSelect = (selectedId: string) => {
    const selectedSubscription = cart.state.bike.bikeSubscriptions.find(
      (item) => item.id === selectedId
    );

    if (selectedSubscription) {
      cart.addSubscription({
        id: selectedSubscription.id,
        title: selectedSubscription.name,
        price: selectedSubscription?.price
      });
    } else {
      console.log("No subscription found for", selectedId);
    }
  };

  if (!selectedSubId) {
    const defaultSubscription = possibleSubscriptions.find((item) => !item.disabled);
    if (defaultSubscription) {
      onInputSelect(defaultSubscription.id);
    }
  }

  return (
    <>
      <Block top={6}>
        <h2>Du har valgt en {title}</h2>
      </Block>
      <Block top={4}>
        <div className={styles.container}>
          {image && <Image className="flex items-center" imageObject={image} />}

          <div className={styles.pricingContainer}>
            <Block bottom={2}>
              <p className={`body-text`}>Velg abonnementet som passer for deg</p>
            </Block>
            <div>
              {possibleSubscriptions.map((subItem, i: number) => {
                return (
                  <div key={subItem.id}>
                    <label className={styles.subscriptionLabel}>
                      <Flex>
                        <RadioButton
                          onChange={onInputSelect}
                          checked={selectedSubId === subItem.id}
                          value={subItem.id}
                          name="subscription"
                          disabled={subItem.disabled}
                        />
                        <Block left={4}>
                          <h3>{subItem.title}</h3>
                          <p>{subItem.commitmentTime}</p>
                          <h3 className="">
                            {subItem.price} <span className="body-text">kr/mnd</span>
                          </h3>
                        </Block>
                      </Flex>
                    </label>

                    {i % 2 === 0 && cart.state.bike?.bikeSubscriptions?.length - 1 !== i && (
                      <Block key={subItem.id} top={4} bottom={4}>
                        <div className={styles.dividerContainer}>
                          <div className={styles.divider} />
                          <p className="text-label">eller</p>
                          <div className={styles.divider} />
                        </div>
                      </Block>
                    )}
                  </div>
                );
              })}
            </div>

            <Block top={6}>
              <div className={styles.buttonGroup}>
                <Button mini onClick={prevStep} link="/" type="submit" secondary>
                  Tilbake
                </Button>
                <Button disabled={!selectedSubId} onClick={goToNextStep} type="submit" primary>
                  Gå videre
                </Button>
              </div>
            </Block>
          </div>
        </div>
      </Block>
    </>
  );
};

export default SubscriptionLength;
